/**
 * Bulletins keys
 */
export const StorageBulletins = {
  artistFormData: 'artist_form-data',
  bandFormData: 'band_form-data',
};
